/** Persist the plugin's single default storefront language before snapshotting a build. */
export async function prepareStorefrontLanguage({ bridgeClient, gatewayClient, shopId }) {
  const response = await bridgeClient.sendMessageWithResponse('register', {}, 30000);
  if (response?.result === 'error') throw new Error(response.error || 'Cannot read store language.');
  const language = response?.data?.shop?.defaultLanguage;
  // Older plugins do not expose this metadata. Keep their existing build setting.
  if (language === undefined) return;
  if (typeof language !== 'string' || !/^[a-z]{2,3}(?:[-_][a-z0-9]{2,8}){0,2}$/i.test(language)) {
    throw new Error('The plugin did not provide a valid default store language.');
  }
  const config = await gatewayClient.loadSearchExperienceConfig(shopId, 'preview');
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    throw new Error('Gateway preview settings are not available.');
  }
  if (config?.language === language) return;
  const result = await gatewayClient.saveSearchExperienceConfig(shopId, { ...config, language }, 'preview');
  if (result?.success === false || result?.errors?.length) {
    throw new Error('Could not save the storefront build language. Update the Gateway and try again.');
  }
  // Old gateways silently discard unknown fields. Do not publish English as a
  // successful French build if the receiving schema did not retain the setting.
  const saved = await gatewayClient.loadSearchExperienceConfig(shopId, 'preview');
  if (saved?.language !== language) throw new Error('Gateway did not retain the storefront build language.');
  for (const command of ['settings.mark_dirty', 'onboarding.invalidatePreview']) {
    const marked = await bridgeClient.sendMessageWithResponse(command, {}, 30000);
    if (marked?.result === 'error') throw new Error(marked.error || 'Could not invalidate the previous build.');
  }
}
